import { put, select } from "redux-saga/effects";
import { API } from 'aws-amplify';
import { getResponseData } from '../../utils/apiHelpers';
import moment from "moment";

import * as actions from "../actions";
import * as selectors from "../selectors/selectors";
import { handleApiError } from '../../utils/apiErrorHandler';

const kryLesings = async (params) => {
    try {
        let apiName = 'API_Aktiwiteite';
        let path = `/verkenning${params ? "?" + params.join("&") : ""}`;
        const response = await API.get(apiName, path, { response: true });
        // console.log(response);
        let lesings;
        if (response.status === 204) {
            lesings = [];
        } else {
            lesings = [...getResponseData(response, [])];
            for (var lesing of lesings) {
                lesing.value = lesing.waarde.value;
                lesing.coordinates = lesing.posisie;
                lesing.date = lesing.datumtyd;
                lesing.capturer = lesing.werknemer.naam;
            }
        }
        return lesings;
    } catch (error) {
        console.log(error);
        console.log(handleApiError(error, { context: 'saga' }));
        throw error;
    }
}

const kryVerkenningLayers = async (params) => {
    try {
        let apiName = 'AWSApiGateway';
        let path = `/layers/aktiwiteite?aktiwiteittipe=verkenning`;
        const response = await API.get(apiName, path, { response: true });
        // console.log(response);
        let data;
        if (response.status === 204) {
            data = [];
        } else {
            data = getResponseData(response, []);
        }
        return data;
    } catch (error) {
        console.log(error);
        console.log(handleApiError(error, { context: 'saga' }));
        throw error;
    }
}

export function* getLayerslysSaga_verkenning(action) {
    try {
        var layers = yield kryVerkenningLayers();
        yield put(actions.setLayerslys_verkenning(layers));
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        yield put(actions.getLayerslysFailed_verkenning(errordata, "Iets het skeefgeloop...", errordata.code, errordata.message));
    }
}

export function* kiesLayerSaga_verkenning(action) {
    try {
        const aktiewelayers = yield select(selectors.layersAkief_verkenning);
        var lesings;
        if (aktiewelayers.indexOf(action.key) > -1) {
            var params = [];
            params.push("aktiwiteit=" + action.key);
            params.push("aantaldae=" + 7);
            lesings = yield kryLesings(params);
            // console.log(lesings);
            yield put(actions.setLayers_verkenning({ id: action.key, data: lesings }));
        } else {
            yield put(actions.removeLayer_verkenning(action.key));
        }
    } catch (error) {
        console.log(error);
    }
}

export function* veranderLayerFilterSaga_verkenning(action) {
    try {
        const aktiewelayers = yield select(selectors.layersAkief_verkenning);
        var params = [];
        params.push("aktiwiteit=" + action.key);
        var lesings;
        if (aktiewelayers.indexOf(action.key) > -1) {
            if (action.tipe === "daterange") {
                params.push("begindatum=" + moment(action.nuwewaarde[0]).endOf("day").format("Y-MM-DD HH:mm:ss"));
                params.push("einddatum=" + moment(action.nuwewaarde[1]).endOf("day").format("Y-MM-DD HH:mm:ss"));
            }
            lesings = yield kryLesings(params);
            // console.log(lesings);
            yield put(actions.setLayers_verkenning({ id: action.key, data: lesings }));
        } else {
            yield put(actions.removeLayer_verkenning(action.key));
        }
    } catch (error) {
        console.log(error);
    }
}